export default "__VITE_ASSET__De_cm7C7__"